import { Extension } from "@tiptap/core";

import HighlightingPlugin from "@/view/TiptapArticleBody/extensions/TextHighlighting/HighlightingPlugin";
import { getAnnotations as annotations, getAnnotationOnClick } from "./utils";

interface IAnnotationsOptions {
  focusAnnotationCard: ((annotationId: string) => void) | null;
}

const Annotations = Extension.create<IAnnotationsOptions>({
  name: "annotations",
  addOptions() {
    return {
      focusAnnotationCard: null,
    };
  },
  addProseMirrorPlugins() {
    const onClick = getAnnotationOnClick(this.options.focusAnnotationCard);

    return [HighlightingPlugin({ annotations, onClick })];
  },
});

export default Annotations;
